/**
 * [PORTABLE] Read-only grid of the Selfie pillar levels.
 * Target path in main project: src/features/onboarding/components/SelfieGrid.tsx
 */
import { useTranslation } from "react-i18next";
import { selfieGridItems } from "../data/selfie-grid";
import { PromptCell, type PromptCellState } from "./PromptCell";
import { cn } from "@/lib/utils";

export type SelfieGridCellState = PromptCellState;

interface SelfieGridProps {
  state: Record<string, SelfieGridCellState>;
  onSelect: (levelId: string) => void;
  cameraIconSrc?: string;
}

export function SelfieGrid({ state, onSelect, cameraIconSrc }: SelfieGridProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-12 md:gap-20 relative z-10 w-full py-8">
      {selfieGridItems.map((item, index) => {
        const cell = state[item.levelId] ?? { unlocked: false, completed: false };
        
        const isActive = cell.unlocked && !cell.completed;
        
        // 🚀 DÜZELTME: Gereksiz sağ-sol padding'ler (pl-12, pr-12) SİLİNDİ.
        // Artık kartlar doğrudan uçlara yaslanacak.
        let alignClass = "justify-center";
        if (index % 3 === 0) alignClass = "md:justify-start justify-center";
        if (index % 3 === 1) alignClass = "justify-center";
        if (index % 3 === 2) alignClass = "md:justify-end justify-center";

        return (
          <div key={item.levelId} className={cn("flex w-full transition-all duration-700", alignClass)}>
            
            <div className={cn(
              "w-full relative group transition-all duration-700 ease-in-out",
              isActive ? "max-w-sm md:max-w-2xl" : "max-w-70 sm:max-w-xs"
            )}>
              <PromptCell
                levelId={item.levelId}
                level={item.level}
                label={t(`onboarding.levels.${item.levelId}.label`)}
                focusLabel={t(`onboarding.levels.${item.levelId}.focus`)}
                emoji={item.emoji}
                state={cell}
                placeholderIconSrc={item.levelId === "S0" ? cameraIconSrc : undefined}
                hideCompletedCheck={item.requiresUpload}
                onSelect={onSelect}
              />
            </div>

          </div>
        );
      })}
    </div>
  );
}